import React, { isValidElement } from 'react';

import { CategoriesTilesSlots } from './CategoriesTilesSlots';
import type { CategoriesTilesProps } from './types';

const initialSlots = {
  header: null,
} as const;

export const useCategoriesTilesSlots = (
  children: CategoriesTilesProps['children'],
) => {
  return React.Children.toArray(children).reduce<
    Record<keyof typeof initialSlots, React.ReactNode>
  >(
    (acc, child) => {
      if (isValidElement(child)) {
        if (child.type === CategoriesTilesSlots.Header) acc.header = child;
      }
      return acc;
    },
    { ...initialSlots },
  );
};
